import { useChatDagRuntime } from '../../../../contexts/ChatDagRuntimeContext';

/**
 * Consumes the derived focal chain. Node-kind dispatchers ask
 * `isFocal(data.turnKey)` to decide compact vs rich rendering.
 * Tab-focus triggers call `setTabFocusTurnId` to light up a turn
 * without scrolling or sending a message.
 */
export function useFocalState() {
  const { focalTurnId, setTabFocusTurnId, tabFocusTurnId } =
    useChatDagRuntime();
  return {
    focalTurnId,
    isFocal: (turnKey: string | undefined | null) =>
      turnKey != null && focalTurnId === turnKey,
    setTabFocusTurnId,
    tabFocusTurnId,
  };
}
